import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { Link, withRouter  } from 'react-router-dom';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../redux/actions';
import Avatar from '@material-ui/core/Avatar';
import MUTypography from '../ui/MUTypography';
import LiNavLink from '../LiNavLink';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Logout from '@mui/icons-material/Logout';
import { history } from '../../App';
import './customCss.css';
import * as icons from './icons'
import _ from 'lodash';
import * as apiDashBoardService from '../NewProcess/apiRequestService';
import PersonIcon from '@mui/icons-material/Person';
import PropTypes from 'prop-types';

const drawerWidth = 304;

function SideMenu2(props) {
  const { window } = props;
  const { classes } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [usersList, setUsersList] = React.useState([]);
  const [currentUser, setCurrentUser] = React.useState(null);
  const open = Boolean(anchorEl);

React.useEffect(() => {
  if (props.login.token) {
      apiDashBoardService.getCurrentUser()
      .then((response) => {
        setCurrentUser(response && response.data ? response.data : null);
      })
      .catch(() => {
        setCurrentUser(null);
      });
  }
}, [props.login.token]);

  const screenMenu=props.login.menu;
  let leftMenu=[];

  if (!_.isNil(screenMenu)) {
    screenMenu.forEach(element => {       
      let newitem={title:element.title,subObject:[]};

      if(!_.isNil(element.subObjects)){
        element.subObjects.forEach(subItem => {
          newitem.subObject.push({link:subItem.link,text:subItem.text,icon:(icons[subItem.icon])});
        });
      }

      leftMenu.push(newitem);
    });
  }


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
      apiDashBoardService.getUsersByCustomerNumber()
        .then((response) => {
          const data = response && response.data ? response.data : [];
          setUsersList(Array.isArray(data) ? data : []);
        })
        .catch(() => {
          setUsersList([]);
        });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    props.actions.logout();
  };

const handleSwitchUser = (userId, fullName, firmName) => {
  setCurrentUser({
    companyName: firmName
  });

  props.actions.switchUser(userId, fullName, firmName);
};

  const drawer = (
    <div>
      <Toolbar>
      <div className='customLogo'>        
          <Link to='/processmanagement'>
            <img src={props.srcImage} alt="Canvas Logo" width={176} height={62}/>
          </Link>
        </div>
        </Toolbar>
      {leftMenu.map((item) => {
        return(
          <div key={item.text}>            
            <List className='customList'>
              {item.subObject.map((subItem) => {
              return(
                <ListItem className='customListItem' key={subItem.text} disablePadding>
                  <ListItemButton className='customListItemButton' href={subItem.link}>
                    <ListItemIcon className='customListItemIcon'>
                      {subItem.icon}
                    </ListItemIcon>
                    <ListItemText className='customListItemText' primary={<MUTypography className={classes.menu}>{subItem.text}</MUTypography>} />
                  </ListItemButton>
                </ListItem>
              )})} 
            </List>
            <Divider className='customDivider' />
          </div>
        );
      })} 
    </div>
  );

  const loginMenu=(
    <div style={{marginLeft:'auto'}}>
    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>

    { props.login.token && props.login.name !== undefined ?
      <Tooltip title="Kullanıcı İşlemleri">
        <IconButton
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? 'account-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <Avatar sx={{ width: 32, height: 32 }}>
            {(() => {
              const matched = usersList.find(u => u.lngUserId === props.login.switchedUserId);

              if (matched && matched.firmName) {
                return matched.firmName.charAt(0).toUpperCase();
              }

              if (currentUser && currentUser.companyName) {
                return currentUser.companyName.charAt(0).toUpperCase();
              }

              if (props.login && props.login.name) {
                return props.login.name.charAt(0).toUpperCase();
            }
            return "";
            })()}
          </Avatar>
        </IconButton>
      </Tooltip>
          :
      <LiNavLink to="/redirect">
        <MUTypography className={classes.typography}>
        LOGIN
        </MUTypography>
      </LiNavLink>
     }
  </Box>
  <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          <MUTypography className={classes.typography}>Oturumu Kapat</MUTypography>
        </MenuItem>
        {usersList.length > 0 && (
          <div>
            <Divider />
            <MenuItem disabled>
              <MUTypography className={classes.typography} style={{ fontWeight: 'bold', fontSize: 12, color: '#888' }}>
                Diğer Oturumlar
              </MUTypography>
            </MenuItem>
            {usersList.map((user) => (
            <MenuItem key={user.lngUserId} onClick={() => handleSwitchUser(user.lngUserId, user.customerName, user.firmName)}><ListItemIcon>
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                <MUTypography className={classes.typography}>{user.firmName}</MUTypography>
              </MenuItem>
            ))}
          </div>
        )}
      </Menu>
  </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;
   
  return (
    <div>
    {props.login.token&&
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        className='customHeader'
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px - 64px)` },
          ml: { sm: `calc(${drawerWidth}px + 64px)` },
          backgroundColor: '#ffffff',
          boxShadow:'none',
          borderBottom: 1,
          borderColor: '#EBEEFF',
        }}
      >
        <Toolbar>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' },color: "#28a5ad" }}
          >
            <MenuIcon />
          </IconButton>

        {props.login.token && props.login.name !== undefined ?
        <div style={{textAlign:"right" ,width:"-webkit-fill-available"}}>
          <MUTypography className={classes.typography}>{currentUser && currentUser.companyName ? currentUser.companyName : props.login.userName}</MUTypography>
        </div>:<div></div>}
        {loginMenu}
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, background: '#EBEEFF', borderRight: 'none' },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, background: '#EBEEFF', borderRight: 'none' },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>}</div>
  );
}

SideMenu2.propTypes = {
  window: PropTypes.object,
  classes: PropTypes.object.isRequired,
  login: PropTypes.object,
  actions: PropTypes.shape({
    logout: PropTypes.func,
    switchUser: PropTypes.func
  }),
  srcImage: PropTypes.string
};

SideMenu2.defaultProps = {
  srcImage: require('../../images/easySignLogo.svg')
};

const mapStateToProps = state => ({
  login: state.login.toJS()
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SideMenu2);

